import "./anexoII1.scss";
import { Formik, Form, ErrorMessage, Field } from "formik";
import { useEffect, useState } from "react";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import Header from "../../components/molecules/header/Header";
import {
  SpinnerCircle,
  SpinnerCircleMini,
} from "../../components/atoms/spinner/Spinner";
import {
  // obtenerDatosUsuario,
  obtenerLocalidades,
  obtenerProvincias,
  obtenerSolicitudPorCod,
  updateSolicitudConcursoAnexoII1,
  insertSolicitudConcursoAnexoII1,
  obtenerSituacionAdministrativa,
} from "../../components/services/ConcursosService";
import { getDatosGrupoF } from "../../components/services/Anexoi1Service";
import { useParams } from "react-router-dom";
import IfError from "../../components/molecules/ifError/IfError";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { getDatosIhPersona } from "../../components/services/IhPersonaService";

const AnexoII1 = () => {
  const [datos, setDatos] = useState({
    // xsolicitud: 0,
    codconcurso: 0,
    dsolicitud: "",
    vvalidada: "",
    tipiep: "",
    letiniiep: "",
    niep: "",
    letfiniep: "",
    apellido1: "",
    apellido2: "",
    nombre: "",
    dtipvia: "",
    dcalle: "",
    dlugfir: "",
    ncalle: "",
    lbis: "",
    escalera: "",
    npiso: "",
    puerta: "",
    cpostal: "",
    loccpais: "",
    loccprovincia: "",
    loccmunicipio: "",
    locclocalidad: "",
    ntelefono: "",
    ntelefono2: "",
    temail: "",
    norden: "",
    loap: "N",
    lobligado: "N",
    admcadmacc: "",
    cgrppro: "",
    grppro: "",
    ccuerpo: "",
    dcuerpo: "",
    ccatpro: "",
    especialidad: "",
    sitcsituacion: "",
    dsituacion: "",
    lcondic: "N",
    tipiepconyuge: "",
    letiniiepconyuge: "",
    niepconyuge: "",
    letfiniepconyuge: "",
    apellido1conyuge: "",
    apellido2conyuge: "",
    nombreconyuge: "",
    fpresentacion: "",
    fregistro: "",
    fmodifica: "",
    modificado: "",
    fcreacion: "",
    creado: "",
    dprovinciafirma: "",
    despecialidad: ""
  });
  const [especialidad, setEspecialidad] = useState([]);
  const [cuerpoEscala, setCuerpoEscala] = useState([]);
  const [disableMunicipio, setDisableMunicipio] = useState(true);
  const [disableCuerpo, setDisableCuerpo] = useState(true);
  const [disableEsp, setDisableEsp] = useState(true);
  const [municipios, setMunicipios] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [datosGrupo, setDatosGrupo] = useState([]);
  const [checkDatos, setCheckDatos] = useState(true);
  const [cargaBoton, setCargaBoton] = useState(false);
  const [combosInicializados, setCombosInicializados] = useState(false); // <- para no rehacer combos mil veces
  
  
  const [user] = useLocalStorage("user", "");
  const params = useParams();

  const [disableGuardar, setDisableGuardar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState({
    mensaje: false,
  });

  let urlEnvio = "";

  const fechaHoy = new Date();
  const opcionesFecha = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const formatoFecha = new Intl.DateTimeFormat('es-ES', opcionesFecha);
  const fechaFormateada = formatoFecha
    .format(fechaHoy)
    .replace(/de/g, '')
    .replace(
      /(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/g,
      (match) => match.charAt(0).toUpperCase() + match.slice(1)
    );

  const comprobarUrl = () => {
    if (params.idsol === undefined) {
      urlEnvio = `/concurso/${params.idcon}`;
    } else {
      urlEnvio = `/consModSolicitudes/${params.idcon}/${params.idsol}`;
    }
  }

  const handleClose = () => {
    setShow(false);
  };

  const handleProvincia = (e) => {
    setDisableMunicipio(true);
    const selectedValue = e.target.selectedOptions[0].value;

    setDatos((prevState) => ({
      ...prevState,
      loccprovincia: selectedValue,
    }));

    obtenerLocalidades(selectedValue).then((data) => {
      setMunicipios(data);
      setDisableMunicipio(false);
      setDatos((prevState) => {
        const updatedState = {
          ...prevState,
          loccmunicipio: data[0].cmunicipio,
          locclocalidad: data[0].clocalidad
        };
        return updatedState;
      });
    });
  };

  const handleGrupo = (e) => {
    const nuevoGrupo = e.target.value;
    const textoGrupo = e.target.selectedOptions[0].text;
    const cuerposDelGrupo = datosGrupo.filter((data) => data.cgrupo === nuevoGrupo);
    setCuerpoEscala(cuerposDelGrupo);

    setDatos((prevState) => ({
      ...prevState,
      cgrppro: nuevoGrupo,
      grppro: textoGrupo,
      ccuerpo: "",
      dcuerpo: "",
      ccatpro: "",
      especialidad: "",
      sitcsituacion: "",
      dsituacion: "",
    }));
    setDisableCuerpo(false);
    setDisableEsp(true);
    setEspecialidad([]);
  };

  const handleCuerpoEscala = (e) => {
    const nuevoCcuerpo = e.target.selectedOptions[0].value;
    const nuevoDcuerpo = e.target.selectedOptions[0].text;

    setDatos((prevState) => ({
      ...prevState,
      ccuerpo: nuevoCcuerpo,
      dcuerpo: nuevoDcuerpo,
    }));

    const especialidadesFiltradas = datosGrupo
      .filter(
        (item) =>
          item.ccuerpo === nuevoCcuerpo &&
          item.cespecialidad &&
          item.despecialidad
      )
      .reduce((acc, item) => {
        const exists = acc.find((e) => e.cespecialidad === item.cespecialidad);
        if (!exists) {
          acc.push({
            cespecialidad: item.cespecialidad,
            despecialidad: item.despecialidad,
          });
        }
        return acc;
      }, []);

    setEspecialidad(especialidadesFiltradas);
    setDisableEsp(especialidadesFiltradas.length === 0);

    if (especialidadesFiltradas.length > 0) {
      const primeraEsp = especialidadesFiltradas[0];
      setDatos((prevState) => ({
        ...prevState,
        ccatpro: primeraEsp.cespecialidad,
        especialidad: primeraEsp.despecialidad,
      }));
    } else {
      setDatos((prevState) => ({
        ...prevState,
        ccatpro: "",
        especialidad: "",
      }));
    }
  };

  const handleEspecialidad = (e) => {
    setDatos((prevState) => ({
      ...prevState,
      ccatpro: e.target.value,
      especialidad: e.target.selectedOptions[0].text,
    }));
  };

  const handleMunicipio = (e) => {
    setDatos((prevState) => ({
      ...prevState,
      loccmunicipio: e.target.selectedOptions[0].value.split("-")[0],
      locclocalidad: e.target.selectedOptions[0].value.split("-")[1],
    }));
  };

  /**
   * CARGA INICIAL:
   * - Si NO hay idsol => alta nueva: usuario + grupos + datos domicilio persona
   * - Si hay idsol => edición: solicitud + grupos
   */
  useEffect(() => {
    // Siempre que cambie la solicitud, marcamos combos sin inicializar
    setCombosInicializados(false);

    if (params?.idsol === null || params?.idsol === undefined) {
      // NUEVA SOLICITUD
      setCheckDatos();
      setDatos((prevState) => ({
        ...prevState,
        apellido1: user.apellido1,
        apellido2: user.apellido2,
        nombre: user.nombre,
        niep: user.niep,
        letfiniep: user.letniep,
      }));

      getDatosGrupoF().then((dataGrupo) => {
        setDatosGrupo(dataGrupo);
      });

      getDatosIhPersona().then((data) => {
        setDatos((prevState) => ({
          ...prevState,
          apellido1: data.apellido1,
          apellido2: data.apellido2,
          nombre: data.nombre,
          niep: data.niep,
          letiniiep: data.letniep,
          locclocalidad: data?.locclocalidad ? data?.locclocalidad : "0001",
          locmunprvcprodom: data?.locmunprvcprodom
            ? data?.locmunprvcprodom
            : "06",
          cpostal: data?.cpostal ? data?.cpostal : "",
          dcalle: data?.dcalle ? data?.dcalle : "",
          locmunprvpaicpaidom: data?.locmunprvpaicpaidom
            ? data?.locmunprvpaicpaidom
            : "724",
          locmuncmunicipio: data?.locmuncmunicipio
            ? data?.locmuncmunicipio
            : "001",
          ntelefono: data?.ntelefono ? data?.ntelefono : "",
          dtipvia: data?.dtipvia ? data?.dtipvia : "",
          ncalle: data?.ncalle ? data?.ncalle : "",
          escalera: data?.escalera ? data?.escalera : "",
          npiso: data?.npiso ? data?.npiso : "",
          puerta: data?.puerta ? data?.puerta : "",
          lbis: data?.lbis === "Y" ? true : false,
          dacldom: data?.dacldom ? data?.dacldom : "",
          temail: data?.cemailper ? data?.cemailper : "",
          loccprovincia: data?.locmunprvcprodom ?? "06",
          loccmunicipio: data?.locmuncmunicipio ?? "001",
        }));
      });
    } else {
      // EDICIÓN DE SOLICITUD EXISTENTE
      obtenerSolicitudPorCod(params?.idsol).then((data) => {

        getDatosGrupoF().then((dataGrupo) => {
          setDatosGrupo(dataGrupo);
    
          
          if (!data.toString().startsWith("Error:")) {
            setCheckDatos(false);
            setDatos((prevState) => ({
              ...prevState,
              dsolicitud: data?.dSolicitud === null ? "" : data?.dSolicitud,
              niep: data?.niep === null ? "" : data?.niep,
              letfiniep: data?.letfiniep === null ? "" : data?.letfiniep,
              letiniiep: data?.letiniiep === null ? "" : data?.letiniiep,
              apellido1: data?.apellido1 === null ? "" : data?.apellido1,
              apellido2: data?.apellido2 === null ? "" : data?.apellido2,
              nombre: data?.nombre === null ? "" : data?.nombre,
              ntelefono: data?.nTelefono === null ? "" : data?.nTelefono,
              ntelefono2: data?.nTelefono2 === null ? "" : data?.nTelefono2,
              temail: data?.tEmail === null ? "" : data?.tEmail,
              dcalle: data?.dCalle === null ? "" : data?.dCalle,
              tipoVia: data?.dtipvia === null ? "" : data?.dtipvia,
              ncalle: data?.nCalle === null ? "" : data?.nCalle,
              escalera: data?.escalera === null ? "" : data?.escalera,
              npiso: data?.nPiso === null ? "" : data?.nPiso,
              cpostal: data?.cPostal === null ? "" : data?.cPostal,
              puerta: data?.puerta === null ? "" : data?.puerta,
              despecialidad: data?.dEspecialidad === null ? "" : data?.dEspecialidad,
              loccpais: data?.locCpais === null ? "" : data?.locCpais,
              norden:
                data?.nOrden === null || data?.nOrden === undefined
                  ? ""
                  : data?.nOrden,
              lbis: data?.lBis === null ? "" : data?.lBis,

              cgrppro: data?.cgrppro === null ? "" : data?.cgrppro,
              ccatpro: data?.cEspecialidad === null ? "" : data?.cEspecialidad,
              ccuerpo: data?.cCuerpo === null ? "" : data?.cCuerpo,

              lobligado: data?.lObligado === null ? "" : data?.lObligado,
              lcondic: data?.lCondic === null ? "" : data?.lCondic,
              niepconyuge: data?.niepConyuge === null ? "" : data?.niepConyuge,
              nombreconyuge:
                data?.nombreConyuge === null ? "" : data?.nombreConyuge,
              dlugfir:
                data?.dLugfir === null ? "" : data?.dLugfir,
              tipiepconyuge:
                data?.tipniepConyuge === null ? "" : data?.tipniepConyuge,
              letiniiepconyuge:
                data?.letiniiepConyuge === null ? "" : data?.letiniiepConyuge,
              letfiniepconyuge:
                data?.letiniiepConyuge === null ? "" : data?.letiniiepConyuge,
              apellido1conyuge:
                data?.apellido1Conyuge === null ? "" : data?.apellido1Conyuge,
              apellido2conyuge:
                data?.apellido2Conyuge === null ? "" : data?.apellido2Conyuge,
              sitcsituacion:
                data?.sitCsituacion === null ? "" : data?.sitCsituacion,
              dsituacion:
                data?.dSituacion === null ? "" : data?.dSituacion,
              dprovinciafirma:
                data?.dprovinciafirma === null ? "" : data?.dprovinciafirma,
            }));

            if (datos.loccprovincia === null || datos.loccprovincia === "") {
              setDatos((prevState) => ({
                ...prevState,
                loccprovincia:
                  data?.locCprovincia === null ? "" : data?.locCprovincia,
                locclocalidad:
                  data?.locClocalidad === null ? "" : data?.locClocalidad,
                loccmunicipio:
                  data?.locCmunicipio === null ? "" : data?.locCmunicipio,
              }));
            }

          } else {
            setDatos(data);
            setCheckDatos(true);
          }
        });
      });
    }
  }, [params, user, datos.loccprovincia]);

  /**
   * Carga de PROVINCIAS (solo cuando ya hemos cargado/decidido datos de la solicitud)
   */
  useEffect(() => {
    if (!checkDatos) {
      obtenerProvincias().then((data) => {
        setLocalidades(data);
        setLoading(true);
      });
    }
  }, [checkDatos]);

  /**
   * Carga de MUNICIPIOS cuando cambia la provincia
   */
  useEffect(() => {
    if (datos.loccprovincia && datos.loccprovincia !== "") {
      setDisableMunicipio(true);
      obtenerLocalidades(datos.loccprovincia).then((dataLoc) => {
        setMunicipios(dataLoc);
        setDisableMunicipio(false);
        const municipioExists = dataLoc.some(
          (m) => m.cmunicipio === datos.loccmunicipio
        );
        if (!municipioExists && dataLoc.length > 0) {
          setDatos((prevState) => ({
            ...prevState,
            loccmunicipio: dataLoc[0].cmunicipio,
            locclocalidad: dataLoc[0].clocalidad,
          }));
        }
      });
    } else {
      setMunicipios([]);
      setDisableMunicipio(true);
      setDatos((prevState) => ({
        ...prevState,
        loccmunicipio: "",
        locclocalidad: "",
      }));
    }
  }, [datos.loccprovincia, datos?.loccmunicipio]);

  /**
   * Cálculo de SITUACIÓN ADMINISTRATIVA cuando hay grupo y cuerpo válidos
   */
  useEffect(() => {
    const cuerpoValido = cuerpoEscala.some(
      (item) => item.ccuerpo === datos.ccuerpo
    );
    if (datos.cgrppro && datos.ccuerpo && cuerpoValido) {
      obtenerSituacionAdministrativa(datos.cgrppro, datos.ccuerpo)
        .then((data) => {
          setDatos((prevState) => ({
            ...prevState,
            sitcsituacion: data?.cSituacion || "",
            dsituacion: data?.dSituacion || "",
          }));
        })
        .catch((err) => {
          // console.error("Error al obtener situación administrativa", err);
          if (
            params?.idsol === null ||
            params?.idsol === undefined
          ) {
            setDatos((prevState) => ({
              ...prevState,
              sitcsituacion: "",
              dsituacion: "",
            }));
          }
        });
    } else {
      if (
        params?.idsol === null ||
        params?.idsol === undefined
      ) {
        setDatos((prevState) => ({
          ...prevState,
          sitcsituacion: "",
          dsituacion: "",
        }));
      }
    }
  }, [datos.cgrppro, datos.ccuerpo, cuerpoEscala, params?.idsol]);

  /**
   * RECONSTRUIR COMBOS (Grupo → Cuerpo → Especialidad) AL CARGAR SOLICITUD
   * usando .find() sobre datosGrupo + datos.cgrppro + datos.ccuerpo + datos.ccatpro
   */
  useEffect(() => {
  if (combosInicializados) return;
  if (!datosGrupo.length) return;

  // 1) DEDUCIR GRUPO A PARTIR DE CUERPO
  if (!datos.cgrppro && datos.ccuerpo) {
    const grupoDeducido = datosGrupo.find(
      g => g.ccuerpo === datos.ccuerpo
    );

    if (grupoDeducido) {
      setDatos(prev => ({
        ...prev,
        cgrppro: grupoDeducido.cgrupo // ← GA
      }));
      return; // esperamos al siguiente render
    }
  }

  // 2) RECONSTRUIR CUERPOS DEL GRUPO
  if (datos.cgrppro) {
    const cuerposDelGrupo = datosGrupo.filter(
      g => g.cgrupo === datos.cgrppro
    );
    setCuerpoEscala(cuerposDelGrupo);
    setDisableCuerpo(false);
  }

  // 3) RECONSTRUIR ESPECIALIDAD DEL CUERPO
  if (datos.ccuerpo) {
    const especialidades = datosGrupo
      .filter(g => g.ccuerpo === datos.ccuerpo && g.cespecialidad)
      .reduce((acc, item) => {
        if (!acc.find(e => e.cespecialidad === item.cespecialidad)) {
          acc.push({
            cespecialidad: item.cespecialidad,
            despecialidad: item.despecialidad,
          });
        }
        return acc;
      }, []);

    setEspecialidad(especialidades);
    setDisableEsp(false);

    // Seleccionamos la especialidad en el formulario
    if (datos.ccatpro) {
      const espSel = especialidades.find(
        e => e.cespecialidad === datos.ccatpro
      );
      if (espSel) {
        setDatos(prev => ({
          ...prev,
          especialidad: espSel.despecialidad
        }));
      }
    }
  }

}, [datosGrupo, datos.ccuerpo, datos.cgrppro, datos.ccatpro, combosInicializados]);


  const comprobarDatos = (errors) => {
    if (
      Object.keys(errors).length === 0 &&
      datos?.loccmunicipio !== null &&
      datos?.loccmunicipio !== "" &&
      datos?.loccprovincia !== null &&
      datos?.loccprovincia !== "" &&
      datos?.cgrppro !== null &&
      datos?.cgrppro !== "" &&
      datos?.ccuerpo !== null &&
      datos?.dcuerpo !== null &&
      datos?.ccatpro !== null &&
      datos?.ccatpro !== ""
    ) {
      setCargaBoton(false);
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <Header></Header>
      <div
        className="container d-flex flex-column min-vh-100 card mt-5"
        id="inicio"
        role="main" data-landmark-index="4"
      >
        {loading ? (
          <>
            <div className="my-auto">
              <div className="container-login">
                <div className="tituloSolicitud">
                  <h2 className="tituloPagina">Anexo II.1</h2>
                  <div className="d-flex align-items-center flex-column">
                    <h2 className="tituloPagina">SOLICITUD DE PARTICIPACIÓN</h2>
                    <p className="text-third-1">{datos.estado}</p>
                  </div>
                  <p className="p-3 text-third-1">Campo obligatorio *</p>
                  <div className="datosPersonales d-flex flex-column">
                    <div className="formulario">
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          dsolicitud:
                            datos.dsolicitud === "" ? `Solicitud ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString([], {
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: false,
                            })}` : datos.dsolicitud,
                          letiniiep:
                            datos.letiniiep === "" ? "" : datos.letiniiep,
                          niep: datos.niep === "" ? "" : datos.niep,
                          letfiniep:
                            datos.letfiniep === "" ? "" : datos.letfiniep,
                          apellido1:
                            datos.apellido1 === "" ? "" : datos.apellido1,
                          apellido2:
                            datos.apellido2 === "" ? "" : datos.apellido2,
                          nombre: datos.nombre === "" ? "" : datos.nombre,
                          dcalle: datos.dcalle === "" ? "" : datos.dcalle,
                          ncalle: datos.ncalle === "" ? "" : datos.ncalle,
                          lbis: datos.lbis === "S" ? true : false,
                          escalera: datos.escalera === "" ? "" : datos.escalera,
                          npiso: datos.npiso === "" ? "" : datos.npiso,
                          puerta: datos.puerta === "" ? "" : datos.puerta,
                          cpostal: datos.cpostal === "" ? "" : datos.cpostal,
                          temail: datos.temail === "" ? "" : datos.temail,
                          norden: datos.norden === "" ? "" : datos.norden,
                          ntelefono:
                            datos.ntelefono === "" ? "" : datos.ntelefono,
                          ntelefono2:
                            datos.ntelefono2 === "" ? "" : datos.ntelefono2,
                          lobligado: datos.lobligado === "S" ? "S" : "N",
                          lcondic: datos.lcondic === "S" ? "S" : "N",
                          cgrppro: datos.cgrppro === "" ? "" : datos.cgrppro,
                          ccuerpo: datos.ccuerpo === "" ? "" : datos.ccuerpo,
                          dsituacion:
                            datos.dsituacion === null
                              ? ""
                              : datos.dsituacion,
                          letiniiepconyuge:
                            datos.letiniiepconyuge === null
                              ? ""
                              : datos.letiniiepconyuge,
                          niepconyuge:
                            datos.niepconyuge === null ? "" : datos.niepconyuge,
                          letfiniepconyuge:
                            datos.letfiniepconyuge === null
                              ? ""
                              : datos.letfiniepconyuge,
                          apellido1conyuge:
                            datos.apellido1conyuge === null
                              ? ""
                              : datos.apellido1conyuge,
                          apellido2conyuge:
                            datos.apellido2conyuge === null
                              ? ""
                              : datos.apellido2conyuge,
                          nombreconyuge:
                            datos.nombreconyuge === null
                              ? ""
                              : datos.nombreconyuge,
                          dprovinciafirma: !datos?.dprovinciafirma ? datos?.dlugfir ? datos?.dlugfir : "" : datos?.dprovinciafirma,
                          sitcsituacion: datos.sitcsituacion === null
                            ? ""
                            : datos.sitcsituacion
                        }}
                        validate={(valores) => {
                          const errores = {};

                          if (
                            valores.dsolicitud == null ||
                            valores.dsolicitud === ""
                          ) {
                            errores.dsolicitud =
                              "Debe introducir una descripción.";
                          }
                          if (valores.niep !== null || valores.niep !== "") {
                            let regex = /^\d{8}$/;
                            let result = regex.test(valores.niep);
                            if (!result) {
                              errores.niep = "Debe introducir un DNI válido.";
                            }
                          }
                          if (
                            valores.letfiniep !== null ||
                            valores.letfiniep !== ""
                          ) {
                            let regex = /^[a-zA-Z]$/;
                            let result = regex.test(valores.letfiniep);
                            if (!result) {
                              errores.letfiniep =
                                "Debe introducir la letra DNI.";
                            }
                          }
                          if (valores.nombre == null || valores.nombre === "") {
                            errores.nombre = "Debe introducir un nombre.";
                          }
                          if (
                            valores.apellido1 == null ||
                            valores.apellido1 === ""
                          ) {
                            errores.apellido1 =
                              "Debe introducir el primer apellido.";
                          }
                          if (
                            valores.apellido2 == null ||
                            valores.apellido2 === ""
                          ) {
                            errores.apellido2 =
                              "Debe introducir el segundo apellido.";
                          }
                          if (
                            (valores.dcalle == null || valores.dcalle === "") &&
                            valores.dcalle !== "S/N"
                          ) {
                            errores.dcalle =
                              "Debe introducir un domicilio o poner S/N.";
                          }
                          if (
                            !/^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/.test(
                              valores.cpostal?.toString()
                            )
                          ) {
                            errores.cpostal =
                              "Debe introducir un Código Postal válido.";
                          }
                          if (valores.ncalle == null || valores.ncalle === "") {
                            errores.ncalle =
                              "Debe introducir un número de calle.";
                          }
                          if (valores.ntelefono && !/^\d{9}$/.test(valores.ntelefono)) {
                            errores.ntelefono = "Debe introducir un teléfono fijo válido (9 dígitos).";
                          }
                          if (!valores.ntelefono2 || !/^\d{9}$/.test(valores.ntelefono2)) {
                            errores.ntelefono2 = "Debe introducir un teléfono móvil válido (9 dígitos).";
                          }
                          if (valores.temail !== null && valores.temail !== "") {
                            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                            const result = regex.test(valores.temail);
                            if (!result) {
                              errores.temail = "Debe introducir un correo electrónico válido.";
                            }
                          } else {
                            errores.temail = "Debe introducir un correo electrónico.";
                          }
                          if (valores.norden == null || valores.norden === "") {
                            errores.norden = "Debe introducir una orden de preferencia.";
                          } else if (isNaN(valores.norden)) {
                            errores.norden = "La orden de preferencia debe ser un número.";
                          }

                          if (Object.keys(errores).length === 0) {
                            setDisableGuardar(true)
                          }
                          return errores;
                        }}
                        onSubmit={(valores) => {

                          const errors = {};
                          setCargaBoton(true);
                          if (comprobarDatos(errors)) {

                            valores.loccmunicipio = `${datos.loccmunicipio}`;
                            valores.locclocalidad = datos.locclocalidad;
                            valores.loccprovincia = datos.loccprovincia;
                            valores.cgrupo = datos.cgrppro;
                            valores.dgrupo = datos.grppro;
                            valores.ccuerpo = datos.ccuerpo;
                            valores.dcuerpo = datos.dcuerpo;
                            valores.cespecialidad = datos.ccatpro;
                            valores.despecialidad = datos.especialidad;
                            valores.sitcsituacion = datos?.sitcsituacion;
                            valores.dsituacion = datos?.dsituacion;
                            valores.codconcurso = params?.idcon;

                            valores.lbis =
                              valores.lbis === true || valores.lbis === "S"
                                ? "S"
                                : "N";

                            valores.tipiep = "";
                            valores.dtipvia = null;
                            valores.vvalidada = "N";
                            valores.loccpais = 724;
                            valores.admcadmacc = null;
                            valores.loap = "N";
                            valores.fpresentacion = null;
                            valores.fregistro = null;
                            valores.fmodificacion = null;
                            valores.modificado = "AE_AREAPERSONAL";
                            valores.fcreacion = "";
                            valores.creado = "AE_AREAPERSONAL";

                            if (
                              params?.idsol === null ||
                              params?.idsol === undefined
                            ) {
                              insertSolicitudConcursoAnexoII1(valores).then(
                                (data) => {
                                  setShow({
                                    mensaje: true,
                                    content: data,
                                    tipo: "tituloModal",
                                    destinoCerrar: `/concurso/${params?.idcon}`,
                                  });
                                }
                              );
                            } else {
                              valores.xsolicitud = params?.idsol;
                              updateSolicitudConcursoAnexoII1(
                                valores,
                                params?.idsol
                              ).then((data) => {
                                setShow({
                                  mensaje: true,
                                  content: data,
                                  tipo: `tituloModal ${data.startsWith("Error:") ? "rojo" : ""
                                    }`,
                                  destinoCerrar: `/concurso/${params?.idcon}`,
                                });
                              });
                            }
                            setCargaBoton(false);
                          }
                        }}
                      >
                        {({ errors }) => (
                          <>
                            <Form>
                              <>

                                <div className="descripcion p-2 d-flex flex-column">
                                  <label htmlFor="dsolicitud">
                                    Descripción de su solicitud
                                    <span className="rojo"> *</span>:
                                    <i
                                      className="fa-regular fa-circle-question ms-2 cursorPointer"
                                      onClick={() => {
                                        setShow({
                                          mensaje: true,
                                          otherContent:
                                            'Ponga nombre a su solicitud para poder identificar el fichero electrónico; es texto libre, escriba lo que quiera: p.e. "Concurso 1"',
                                          tipo: "tituloModal",
                                          destinoCerrar: null,
                                        });
                                      }}
                                    ></i>
                                  </label>

                                  <div className="d-flex ">
                                    <Field
                                      type="text"
                                      id="dsolicitud"
                                      name="dsolicitud"
                                      className="form-control ms-2"
                                      maxLength="99"
                                    />
                                  </div>
                                  <ErrorMessage
                                    name="descripcion"
                                    component={() => (
                                      <div className="error rojo pt-2 ps-2">
                                        {errors.dsolicitud}
                                      </div>
                                    )}
                                  />
                                </div>

                                <div className="infoSolicitud">
                                  <div className="instrucciones">
                                    <p className="my-3 mx-2">
                                      El personal laboral cuyos datos figuran a
                                      continuación SOLICITA:
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <div className="d-flex justify-content-between">
                                    <h4 className="tituloPagina">1. Datos del Participante</h4>
                                  </div>
                                </div>

                                <div className="formularioDatosPesonales p-2">
                                  <div className="datosDNI m-2">
                                    <label htmlFor="dni" className="tituloForm">
                                      DNI o Pasaporte:
                                    </label>
                                    <div className="d-flex">
                                      <Field
                                        type="text"
                                        id="dni"
                                        name="letiniiep"
                                        className="form-control m-1 w-25"
                                        maxLength="1"
                                        disabled
                                      />
                                      <Field
                                        type="text"
                                        id="dni"
                                        name="niep"
                                        className="form-control m-1"
                                        disabled
                                      />
                                      <Field
                                        type="text"
                                        id="letfiniep"
                                        name="letfiniep"
                                        className="form-control m-1 w-25"
                                        maxLength="1"
                                        disabled
                                      />
                                    </div>
                                    <ErrorMessage
                                      name="letfiniep"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.letfiniep}
                                        </div>
                                      )}
                                    />
                                    <ErrorMessage
                                      name="dni"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.niep}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="ape1 m-2">
                                    <label htmlFor="apellido1" className="tituloForm">
                                      Primer apellido:
                                    </label>
                                    <Field
                                      type="text"
                                      id="apellido1"
                                      name="apellido1"
                                      className="form-control"
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="apellido1"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.apellido1}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="ape2 m-2">
                                    <label htmlFor="apellido2" className="tituloForm">
                                      Segundo apellido:
                                    </label>
                                    <Field
                                      type="text"
                                      id="apellido2"
                                      name="apellido2"
                                      className="form-control"
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="apellido2"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.apellido2}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="nombre m-2">
                                    <label htmlFor="nombre" className="tituloForm">
                                      Nombre <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="nombre"
                                      name="nombre"
                                      className="form-control"
                                      disabled
                                    />
                                    <ErrorMessage
                                      name="nombre"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.nombre}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="tlfFijo m-2">
                                    <label htmlFor="ntelefono" className="tituloForm">
                                      Teléfono fijo:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ntelefono"
                                      name="ntelefono"
                                      className="form-control"
                                    />
                                    <ErrorMessage
                                      name="ntelefono"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.ntelefono}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="tlfMovil m-2">
                                    <label htmlFor="ntelefono2" className="tituloForm">
                                      Teléfono móvil{" "}
                                      <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="ntelefono2"
                                      name="ntelefono2"
                                      className="form-control"
                                    />
                                    <ErrorMessage
                                      name="ntelefono2"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.ntelefono2}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="email m-2">
                                    <label htmlFor="temail" className="tituloForm">
                                      Correo electrónico{" "}
                                      <span className="rojo">*</span>
                                      :
                                    </label>
                                    <Field
                                      type="cemailcor"
                                      id="temail"
                                      name="temail"
                                      className="form-control"
                                      maxLength="79"
                                    />
                                    <ErrorMessage
                                      name="temail"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.temail}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="via m-2">
                                    <label htmlFor="dcalle" className="tituloForm">
                                      Vía <span className="rojo">*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="dcalle"
                                      name="dcalle"
                                      className="form-control"
                                      maxLength="79"
                                    />
                                    <ErrorMessage
                                      name="dcalle"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.dcalle}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="numeroBis m-2">
                                    <div className="numero">
                                      <label htmlFor="ncalle" className="tituloForm">
                                        Nº <span className="rojo">*</span>:
                                      </label>
                                      <Field
                                        type="text"
                                        id="ncalle"
                                        name="ncalle"
                                        className="form-control"
                                        maxLength="5"
                                      />
                                    </div>
                                    <div className="bis d-flex align-items-center justify-content-center">
                                      <label htmlFor="lbis" className="tituloForm">Bis:</label>{" "}
                                      <Field
                                        type="checkbox"
                                        id="lbis"
                                        name="lbis"
                                        className="form-check-input checkBis"
                                      />
                                    </div>
                                    <div className="mensajeNumeroBis">
                                      <ErrorMessage
                                        name="ncalle"
                                        component={() => (
                                          <div className="error rojo pt-2">
                                            {errors.ncalle}
                                          </div>
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="escalera m-2">
                                    <label htmlFor="escalera" className="tituloForm">Escalera:</label>
                                    <Field
                                      type="text"
                                      id="escalera"
                                      name="escalera"
                                      className="form-control"
                                      maxLength="5"
                                    />
                                  </div>
                                  <div className="piso m-2">
                                    <label htmlFor="npiso" className="tituloForm">Piso:</label>
                                    <Field
                                      type="text"
                                      id="npiso"
                                      name="npiso"
                                      className="form-control"
                                      maxLength="5"
                                    />
                                  </div>
                                  <div className="puerta m-2">
                                    <label htmlFor="puerta" className="tituloForm">Puerta:</label>
                                    <Field
                                      type="text"
                                      id="puerta"
                                      name="puerta"
                                      className="form-control"
                                      defaultValue={"00"}
                                      maxLength="5"
                                    />
                                  </div>
                                  <div className="cp m-2">
                                    <label htmlFor="cpostal" className="tituloForm">
                                      CP <span className="rojo tituloForm" >*</span>:
                                    </label>
                                    <Field
                                      type="text"
                                      id="cpostal"
                                      name="cpostal"
                                      className="form-control"
                                    />
                                    <ErrorMessage
                                      name="cpostal"
                                      component={() => (
                                        <div className="error rojo pt-2">
                                          {errors.cpostal}
                                        </div>
                                      )}
                                    />
                                  </div>
                                  <div className="localidad m-2">
                                    <label htmlFor="loccmunicipio" className="tituloForm">
                                      Municipio <span className="rojo">*</span>:
                                    </label>
                                    {disableMunicipio &&
                                      datos.loccprovincia !== "" ? (
                                      <>
                                        <SpinnerCircleMini></SpinnerCircleMini>
                                      </>
                                    ) : (
                                      <>
                                        <select
                                          name="loccmunicipio"
                                          id="loccmunicipio"
                                          className="form-select"
                                          onChange={handleMunicipio}
                                          defaultValue={`${datos?.loccmunicipio}-${datos?.locclocalidad}`}
                                          disabled={disableMunicipio}
                                        >
                                          <option value="" disabled>
                                            Seleccione una opción
                                          </option>
                                          {municipios?.map((municipio, i) => (
                                            <option
                                              value={`${municipio.cmunicipio}-${municipio.clocalidad}`}
                                              key={i}
                                              defaultValue={
                                                municipio.id ===
                                                  datos.loccmunicipio
                                                  ? true
                                                  : false
                                              }
                                            >
                                              {municipio.dlocalidad}
                                            </option>
                                          ))}
                                        </select>
                                      </>
                                    )}
                                    {(datos?.loccmunicipio === null ||
                                      datos?.loccmunicipio === "") &&
                                      !disableGuardar ? (
                                      <>
                                        <div className="error rojo pt-2">
                                          Debe seleccionar un Municipio.
                                        </div>
                                      </>
                                    ) : null}
                                  </div>
                                  <div className="provincia m-2">
                                    <label htmlFor="loccprovincia" className="tituloForm">
                                      Provincia <span className="rojo tituloForm">*</span>:
                                    </label>
                                    <select
                                      name="loccprovincia"
                                      id="loccprovincia"
                                      className="form-select"
                                      onChange={handleProvincia}
                                      defaultValue={
                                        datos.loccprovincia
                                      }
                                    >
                                      <option value="" disabled>
                                        Seleccione una opción
                                      </option>
                                      {localidades.map((localidad, i) => (
                                        <option value={localidad.id} key={i}>
                                          {localidad.value}
                                        </option>
                                      ))}
                                    </select>
                                    {(datos?.loccprovincia === null ||
                                      datos?.loccprovincia === "") &&
                                      !disableGuardar ? (
                                      <>
                                        <div className="error rojo pt-2">
                                          Debe seleccionar una provincia.
                                        </div>
                                      </>
                                    ) : null}
                                  </div>
                                </div>
                              </>

                              <div className="d-flex justify-content-between">
                                <h4 className="tituloPagina">2. Datos de participación</h4>
                              </div>
                              <div className="datosParticipacion2">
                                <div className="ordenPref m-2">
                                  <label htmlFor="norden" className="tituloForm">
                                    Orden de preferencia de la solicitud{" "}
                                    <span className="rojo">*</span>:
                                  </label>
                                  <Field
                                    type="text"
                                    id="norden"
                                    name="norden"
                                    className="form-control"
                                    maxLength="4"
                                  />
                                  <ErrorMessage
                                    name="norden"
                                    component={() => (
                                      <div className="error rojo pt-2">
                                        {errors.norden}
                                      </div>
                                    )}
                                  />
                                </div>
                                <div className="grupo m-2">
                                  <label htmlFor="cgrppro" className="tituloForm">
                                    Grupo <span className="rojo">*</span>:
                                  </label>
                                  <select
                                    name="cgrppro"
                                    className="form-select"
                                    onChange={handleGrupo}
                                    value={datos.cgrppro || ""}
                                  >
                                    <option value="" disabled>
                                      Seleccione una opción
                                    </option>
                                    {datosGrupo.map((grupo, i) => (
                                      <option value={grupo.cgrupo} key={i}>
                                        {grupo.dgrupo}
                                      </option>
                                    ))}
                                  </select>
                                  {(datos?.cgrppro === null ||
                                    datos?.cgrppro === "") &&
                                    disableGuardar ? (
                                    <>
                                      <div className="error rojo pt-2">
                                        Debe seleccionar un grupo.
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                                <div className="obliga m-2 d-flex justify-content-between">
                                  <label htmlFor="lobligado" className="tituloForm">
                                    ¿Está obligado a concursar?:
                                  </label>
                                  <div className="form-check">
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="lobligado"
                                      id="obligaSi"
                                      value="S"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="obligaSi"
                                    >
                                      Si
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="lobligado"
                                      id="obligaNo"
                                      value="N"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="obligaNo"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                                <div className="cuerpoEscala m-2">
                                  <label htmlFor="ccuerpo" className="tituloForm">
                                    Cuerpo / Escala{" "}
                                    {!disableCuerpo ? (
                                      <>
                                        <span className="rojo">*</span>
                                      </>
                                    ) : null}
                                    :
                                  </label>
                                  <select
                                    name="ccuerpo"
                                    className="form-select"
                                    onChange={handleCuerpoEscala}
                                    disabled={disableCuerpo}
                                    value={datos.ccuerpo || ""}
                                  >
                                    <option value="">
                                      Seleccione una opción
                                    </option>
                                    {cuerpoEscala.map((cuerpo, i) => (
                                      <option value={cuerpo.ccuerpo} key={i}>
                                        {cuerpo.dcuerpo}
                                      </option>
                                    ))}
                                  </select>
                                  {(datos?.ccuerpo === null ||
                                    datos?.ccuerpo === "") &&
                                    disableGuardar &&
                                    !disableCuerpo ? (
                                    <>
                                      <div className="error rojo pt-2">
                                        Debe seleccionar un Cuerpo/Escala.
                                      </div>
                                    </>
                                  ) : null}
                                </div>

                                <div className="especialidad m-2">
                                  <label htmlFor="ccatpro" className="tituloForm">
                                    Especialidad{" "}
                                    {!disableCuerpo ? (
                                      <>
                                        <span className="rojo">*</span>
                                      </>
                                    ) : null}
                                    :
                                  </label>
                                  <select
                                    name="ccatpro"
                                    className="form-select"
                                    onChange={handleEspecialidad}
                                    disabled={disableEsp}
                                    value={datos.ccatpro || ""}
                                  >
                                    <option value="">Seleccione una opción</option>
                                    {especialidad.map((esp, i) => (
                                      <option value={esp.cespecialidad} key={i}>
                                        {esp.despecialidad}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="sitAdmin2 m-2">
                                  <label htmlFor="dsituacion" className="tituloForm">
                                    Situación administrativa:
                                  </label>
                                  <Field
                                    type="text"
                                    id="dsituacion"
                                    name="dsituacion"
                                    className="form-control"
                                    readOnly
                                    disabled
                                    value={datos?.dsituacion}
                                  />
                                </div>
                              </div>

                              <div className="d-flex justify-content-between">
                                <h4 className="tituloPagina">3. Condicionamiento por convivencia familiar</h4>
                              </div>
                              <div className="condicionamiento m-2">
                                <div className="condicionamientoCF m-2 d-flex justify-content-between">
                                  <label htmlFor="lcondic" className="tituloForm">
                                    ¿Condiciona su participación a otra
                                    solicitud por motivos de conviviencia
                                    familiar?
                                  </label>
                                  <div className="form-check">
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="lcondic"
                                      id="condicionamientoCFSi"
                                      value="S"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="condicionamientoCFSi"
                                    >
                                      Si
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <Field
                                      className="form-check-input"
                                      type="radio"
                                      name="lcondic"
                                      id="condicionamientoCFNo"
                                      value="N"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="condicionamientoCFNo"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>

                                <div className="infoCF">
                                  <p>
                                    Indique los datos de la solicitud a la que
                                    se condiciona:
                                  </p>
                                </div>
                                <div className="dniCF">
                                  <label htmlFor="niepconyuge" className="tituloForm">
                                    DNI o Pasaporte:
                                  </label>
                                  <div className="d-flex">
                                    <Field
                                      type="text"
                                      id="letiniiepconyuge"
                                      name="letiniiepconyuge"
                                      className="form-control m-1 w-25"
                                      maxLength="1"
                                    />
                                    <Field
                                      type="text"
                                      id="niepconyuge"
                                      name="niepconyuge"
                                      className="form-control m-1"
                                    />
                                    <Field
                                      type="text"
                                      id="letfiniepconyuge"
                                      name="letfiniepconyuge"
                                      className="form-control m-1 w-25"
                                      maxLength="1"
                                    />
                                  </div>
                                </div>

                                <div className="apellido1CF mx-2">
                                  <label htmlFor="apellido1conyuge" className="tituloForm">
                                    Primer apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="apellido1conyuge"
                                    name="apellido1conyuge"
                                    className="form-control"
                                  />
                                </div>
                                <div className="apellido2CF mx-2">
                                  <label htmlFor="apellido2conyuge" className="tituloForm">
                                    Segundo apellido:
                                  </label>
                                  <Field
                                    type="text"
                                    id="apellido2conyuge"
                                    name="apellido2conyuge"
                                    className="form-control"
                                  />
                                </div>
                                <div className="nombreCF mx-2">
                                  <label htmlFor="nombreconyuge" className="tituloForm">Nombre:</label>
                                  <Field
                                    type="text"
                                    id="nombreconyuge"
                                    name="nombreconyuge"
                                    className="form-control"
                                  />
                                </div>
                              </div>

                              <div className="lugarFechaFirma">
                                <div className="d-flex justify-content-between">
                                  <h4 className="tituloPagina">Lugar, Fecha y Firma</h4>
                                </div>
                                <div className="infoFirma">
                                  <p className="ms-2 mb-5">
                                    El abajo firmante declara, bajo su expresa responsabilidad, ser ciertos cuantos datos figuran en la presente solicitud.
                                  </p>
                                  <div className="row d-flex justify-content-center align-items-center mb-5">
                                    <p className="col-md-1 text-md-end text-center">En </p>
                                    <div className="lugarFirma col-md-3">
                                      <Field
                                        type="text"
                                        id="dprovinciafirma"
                                        name="dprovinciafirma"
                                        className="form-control"
                                        maxLength="199"
                                      />
                                    </div>

                                    <p className="col-md-3 text-md-start text-center">, a {fechaFormateada}</p>
                                  </div>
                                  <div className="nombrefirma d-flex justify-content-center">
                                    <p className="fw-bold">Fdo.: {datos?.nombre} {datos?.apellido1} {datos?.apellido2}</p>
                                  </div>
                                </div>
                              </div>
                              <div className="footer p-2">
                                <p>
                                  En cumplimiento de lo dispuesto en la Ley
                                  Orgánica 15/1999, de 13 de diciembre, de
                                  Protección de Datos de Carácter Personal, la
                                  Consejería de Hacienda y Administración
                                  Pública le informa que sus datos personales
                                  obtenidos mediante la cumplimentación de este
                                  documento/impreso/formulario y demás que se
                                  adjunten van a ser incorporados, para su
                                  tratamiento, en un fichero automatizado que
                                  tratará los datos de todos los participantes
                                  en la convocación conforme al procedimiento
                                  establecido en la misma. De acuerdo con lo
                                  previsto en la citada Ley Orgánica, pude
                                  ejercitar los derechos de acceso,
                                  rectificación o cancelación y oposición ante
                                  el órgano correspondiente.
                                </p>
                                <p>
                                  (1) Si posee más de una categoría /
                                  especialidad y va a participar por más de una
                                  de ellas, deberá usar este campo para indicar
                                  el orden de preferencia de esta solicitud
                                  entre todas las que presente para esta
                                  convocatoria.
                                </p>
                              </div>
                              <div className="d-flex justify-content-center gap-3 mt-4 row">
                                <div className="col-md-5 order-2 order-md-1">
                                  <button
                                    id="guardarAnexoii3"
                                    className="btnRed rounded m-2 botonVolverAnexoII1"
                                    type="button"
                                    onClick={() => [
                                      comprobarUrl(),
                                      setShow({
                                        mensaje: true,
                                        content: "¿Deseas cancelar el formulario?",
                                        tipo: "tituloModal",
                                        aviso: true,
                                        destinoAviso: `${urlEnvio}`,
                                      })]
                                    }
                                  >
                                    <i className="fa-solid fa-rotate-left"></i>{" "}
                                    Volver
                                  </button>
                                </div>

                                <div className="col-md-5 order-1 order-md-2">
                                  <button
                                    id="grabarAnexoii1"
                                    className="btn m-2 botonGuardarAnexoII1"
                                    type="submit"
                                    onClick={() => {
                                      setCargaBoton(true);
                                      if (!comprobarDatos(errors)) {
                                        setShow({
                                          mensaje: true,
                                          content:
                                            "Es necesario completar los datos obligatorios.",
                                          tipo: "tituloModal rojo",
                                          destinoCerrar: null,
                                        });
                                        setCargaBoton(false);
                                      }
                                    }}
                                    disabled={
                                      !disableGuardar
                                        ? !disableGuardar
                                        : disableGuardar
                                          ? cargaBoton
                                          : false
                                    }
                                  >
                                    {cargaBoton ? (
                                      <>
                                        <div className="d-flex justify-content-center">
                                          <SpinnerCircleMini
                                            clases={"background-border"}
                                          ></SpinnerCircleMini>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <i className="fa-solid fa-save"></i>{" "}
                                        Guardar
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </Form>
                          </>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : !datos.toString().startsWith("Error:") ? (
          <>
            <div className="error fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <SpinnerCircle></SpinnerCircle>
            </div>
          </>
        ) : (
          <>
            <div className="error fs-4 pt-2 d-flex align-items-center flex-column my-auto">
              <IfError
                mensage="Error: Fallo en intentar obtener los datos de usuario."
                ruta="/home"
              ></IfError>
            </div>
          </>
        )}
      </div >
      {
        show.mensaje ? (
          <ModalMensajes
            show={show.mensaje}
            handleClose={handleClose}
            texto={show.content}
            tipo={show.tipo}
            aviso={show.aviso}
            destinoAviso={show.destinoAviso}
            otherContent={show.otherContent}
            destinoCerrar={show?.destinoCerrar}
          ></ModalMensajes>
        ) : null
      }
      <Footer ></Footer>
    </>
  );
};

export default AnexoII1;
